import api from "./axiosInstance";

export const WareHouseApi = {
  getWareHouses: async () => {
    const response = await api.get("/getWareHouses");
    return response.data;
  },
  getCategory: async () => {
    const response = await api.get("/getCategory");
    return response.data;
  },
  getGodownStock: async (data) => {
    const response = await api.post("/getGodownStock", data);
    return response.data;
  },
  getGodownTransferReport: async (data) => {
    const response = await api.post("/getGodownTransferReport", data);
    return response.data;
  },
};
